<template>
  <div id="container">
    <div id="vid_container">
      <video id="video" autoplay playsinline></video>
      <div id="video_overlay"></div>
    </div>
    <div id="gui_controls">
      <v-btn @click="takePhotoAction">照相</v-btn>
    </div>
  </div>
</template>
<script>
import faceapi from "face-api.js";


export default {
  name: "FaceRecognitionView",
  data() {
    return {      
      video: Object,    
      amountOfCameras: 0,
      currentFacingMode: "user",
    };
  },
  mounted() {
    // check if mediaDevices is supported
    if (
      navigator.mediaDevices &&
      navigator.mediaDevices.getUserMedia &&
      navigator.mediaDevices.enumerateDevices
    ) {
      navigator.mediaDevices
        .getUserMedia({
          audio: false,
          video: {
            facingMode: this.currentFacingMode
          }
        })
        .then((stream) => {
          stream.getTracks().forEach((track) => {
            track.stop();
          });

          this.deviceCount().then((deviceCount) => {
            console.log(`deviceCount === ${deviceCount}`);
            this.amountOfCameras = deviceCount;
            // init the UI and the camera stream
            this.initCameraUI();
            this.initCameraStream();
          });
        })
        .catch(error => {
          if (error === "PermissionDeniedError") {
            alert("Permission denied. Please refresh and give permission.");
          }

          console.error("getUserMedia() error: ", error);
        });
    } else {
      alert(
        "Mobile camera is not supported by browser, or there is no camera detected/connected"
      );
    }
  },
  methods: {
    deviceCount() {
      return new Promise((resolve) => {
        var videoInCount = 0;

        navigator.mediaDevices
          .enumerateDevices()
          .then(function (devices) {
            devices.forEach(function (device) {
              if (device.kind === "video") {
                device.kind = "videoinput";
              }

              if (device.kind === "videoinput") {
                videoInCount++;
                console.log("videocam: " + device.label);
              }
            });

            resolve(videoInCount);
          })
          .catch(function (err) {
            console.log(err.name + ": " + err.message);
            resolve(0);
          });
      });
    },

    initCameraUI() {
      console.log(`initCameraUI`);
      this.video = document.getElementById("video");

      // window.addEventListener(
      //   "orientationchange",
      //   function () {
      //     // iOS doesn't have screen.orientation, so fallback to window.orientation.
      //     // screen.orientation will
      //     if (screen.orientation) angle = screen.orientation.angle;
      //     else angle = window.orientation;

      //     var guiControls = document.getElementById("gui_controls").classList;
      //     var vidContainer = document.getElementById("vid_container").classList;

      //     if (angle == 270 || angle == -90) {
      //       guiControls.add("left");
      //       vidContainer.add("left");
      //     } else {
      //       if (guiControls.contains("left")) guiControls.remove("left");
      //       if (vidContainer.contains("left")) vidContainer.remove("left");
      //     }

      //   },
      //   false
      // );
    },

    // https://github.com/webrtc/samples/blob/gh-pages/src/content/devices/input-output/js/main.js
    initCameraStream() {
      console.log(`initCameraStream`);
      if (window.stream) {
        window.stream.getTracks().forEach((track) => {
          console.log(track);
          track.stop();
        });
      }

      // we ask for a square resolution, it will cropped on top (landscape)
      // or cropped at the sides (landscape)
      var size = 1280;

      var constraints = {
        audio: false,
        video: {
          width: { ideal: size },
          height: { ideal: size },
          //width: { min: 1024, ideal: window.innerWidth, max: 1920 },
          //height: { min: 776, ideal: window.innerHeight, max: 1080 },
          facingMode: this.currentFacingMode,
        },
      };

      navigator.mediaDevices
        .getUserMedia(constraints)
        .then((stream) => {
          window.stream = stream; // make stream available to browser console
          this.video.srcObject = stream;

          const track = window.stream.getVideoTracks()[0];
          const settings = track.getSettings();
          let str = JSON.stringify(settings, null, 4);
          console.log("settings " + str);
        })
        .catch((error) => {
          console.error("getUserMedia() error: ", error);
        });
    },
    takePhotoAction() {
      this.createClickFeedbackUI();
      this.takeSnapshot();
    },    
    takeSnapshot() {
      // if you'd like to show the canvas add it to the DOM
      var canvas = document.createElement("canvas");

      var width = this.video.videoWidth;
      var height = this.video.videoHeight;

      canvas.width = width;
      canvas.height = height;

      var context = canvas.getContext("2d");
      context.drawImage(this.video, 0, 0, width, height);

      // polyfil if needed https://github.com/blueimp/JavaScript-Canvas-to-Blob

      // https://developers.google.com/web/fundamentals/primers/promises
      // https://stackoverflow.com/questions/42458849/access-blob-value-outside-of-canvas-toblob-async-function
      function getCanvasBlob(canvas) {
        return new Promise(function (resolve, reject) {
          canvas.toBlob(function (blob) {
            resolve(blob);
          }, "image/jpeg");
        });
      }

      // some API's (like Azure Custom Vision) need a blob with image data
      getCanvasBlob(canvas).then(blob => {
        console.log(`takeSnapshot === ${JSON.stringify( blob)}`)
        // do something with the image blob
      });
    },
    createClickFeedbackUI() {
      var overlay = document.getElementById("video_overlay"); //.style.display;

      var overlayVisibility = false;
      var timeOut = 80;

      function setFalseAgain() {
        overlayVisibility = false;
        overlay.style.display = "none";
      }

      return function () {
        if (overlayVisibility == false) {
          // sndClick.play();
          overlayVisibility = true;
          overlay.style.display = "block";
          setTimeout(setFalseAgain, timeOut);
        }
      };
    },
  },
};
</script>

<style scoped>

body {
  margin: 0px;
  padding: 0px;
  background: #000;
}

#vid_container {
  position: fixed;
  top: 0;
  left: 0;
}

#video {
  width: 100%;
  height: 100%;
  object-fit: cover;
  z-index: 0;
}

#gui_controls {
  position: fixed;
  background-color: #111; /*rgba(255, 0, 0, 0.5);*/
  z-index: 2;
  bottom: 0;
}

#video_overlay {
  position: fixed;
  display: none;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;

  z-index: 10;
  background-color: #111;
}

@media screen and (orientation: portrait) {
  /* portrait-specific styles */

  /* video_container (video) doesn't respect height... 
       so we will fill it in completely in portrait mode
    */
  #vid_container {
    width: 100%;
    height: 80%;
  }

  #gui_controls {
    width: 100%;
    height: 20%;
    left: 0;
  }

}

@media screen and (orientation: landscape) {
  #vid_container {
    width: 80%;
    height: 100%;
  }

  #vid_container.left {
    left: 20%;
  }

  /* we default to right */
  #gui_controls {
    width: 20%;
    height: 100%;
    right: 0;
  }

  /* for the lefties */
  #gui_controls.left {
    left: 0;
  }
}

</style>


// WEBPACK FOOTER //
// src/pages/web/FaceRecognitionView.vue